'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _formField = require('./form-field');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_formField).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }